import React, { useState } from 'react';
import Layout from './components/Layout';
import Header from './components/Header';
import { Radio, RadioGroup } from '../../components/common/Radio';
import { Playground, Control } from './components/Playground';
import styles from './Radio.module.css';

const demoOptions = [
  { value: 'option1', label: '옵션 1' },
  { value: 'option2', label: '옵션 2' },
  { value: 'option3', label: '옵션 3' },
];

const RadioPlayground = () => {
  const [radioConfig, setRadioConfig] = useState({
    label: '레이블',
    description: '',
    error: '',
    disabled: false,
    selectedValue: 'option1',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRadioConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <Playground
      controls={
        <>
          <Control
            label="그룹 레이블"
            name="label"
            value={radioConfig.label}
            onChange={handleChange}
          />
          <Control
            label="설명"
            name="description"
            value={radioConfig.description}
            onChange={handleChange}
          />
          <Control
            label="에러 메시지"
            name="error"
            value={radioConfig.error}
            onChange={handleChange}
          />
          <Control
            type="checkbox"
            label="비활성화"
            name="disabled"
            checked={radioConfig.disabled}
            onChange={handleChange}
          />
        </>
      }
      preview={
        <div style={{ width: '100%', maxWidth: '320px' }}>
          <RadioGroup
            label={radioConfig.label || undefined}
            options={demoOptions}
            description={radioConfig.description || undefined}
            error={radioConfig.error || undefined}
            disabled={radioConfig.disabled}
            value={radioConfig.selectedValue}
            onChange={(e) => setRadioConfig(prev => ({ ...prev, selectedValue: e.target.value }))}
            name="playground-radio"
          />
        </div>
      }
    />
  );
};

const RadioDemo = () => {
  const [selectedValue, setSelectedValue] = useState('option1');

  return (
    <Layout>
      <div className={styles.container}>
        <Header 
          title="라디오"
          description="사용자가 여러 옵션 중 하나를 선택할 수 있는 라디오 컴포넌트입니다."
        />

        <RadioPlayground />

        <section className={styles.demoSection}>
          <h2>상태</h2>
          <div className={styles.demoGrid}>
            <div className={styles.demoWrapper}>
              <h3>기본</h3>
              <RadioGroup
                options={demoOptions}
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                name="demo-basic"
              />
            </div>

            <div className={styles.demoWrapper}>
              <h3>비활성화</h3>
              <RadioGroup
                options={demoOptions}
                disabled
                value={selectedValue}
                name="demo-disabled"
              />
            </div>

            <div className={styles.demoWrapper}>
              <h3>에러</h3>
              <RadioGroup
                options={demoOptions}
                error="필수 항목입니다"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                name="demo-error"
              />
            </div>
          </div>
        </section>

        <section className={styles.demoSection}>
          <h2>레이블과 설명</h2>
          <div className={styles.demoGrid}>
            <div className={styles.demoWrapper}>
              <h3>레이블</h3>
              <RadioGroup
                label="레이블"
                options={demoOptions}
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                name="demo-label"
              />
            </div>

            <div className={styles.demoWrapper}>
              <h3>설명</h3>
              <RadioGroup
                label="선호도"
                options={demoOptions}
                description="선호하는 옵션을 선택해주세요"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                name="demo-description"
              />
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default RadioDemo; 